export enum CustomerLockingReasonType {
  DEPARTED = 'departed',
  SUSPICION_OF_FRAUD = 'suspicion_of_fraud',
  ENCASHMENT = 'encashment',
  BLACKLIST = 'blacklist',
  STADIUM_BAN = 'stadium_ban',
  OTHER_REASON = 'other_reason',
  CUSTOMER_REQUEST = 'customer_request',
  CHARGE_BACK = 'charge_back',
  DIRECT_DEBIT_RECALL = 'direct_debit_recall',
  UNKNOWN = 'unknown'
}
